'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FIELD_META_PROP = exports.FIELD_META_PROP = 'data-__meta';


/*****************
 ** WEBPACK FOOTER
 ** ./components/form/constants.js
 ** module id = 98
 ** module chunks = 0
 **/